import type { FC } from 'react'
import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import Card from './Components/Card'

const copy = {
  heading: (
    <>
      See why reviewers on
      {` `}
      <a href="https://www.g2.com/products/segment/reviews" target="_blank">
        G2
      </a>
      {` `}
      love Segment
    </>
  ),
  reviews: [
    {
      description: `“Exceptional product, with amazing support! I've been using Segment for a while now, and the product has delivered on the core promise every single time. Segment makes data collection incredibly easy. Thus businesses can benefit from the power of data at any stage of development. Not even mentioning the power of having data from various sources under one roof.”`,
      author: `Giorgi Shelia — Product Marketing`,
    },
    {
      description: `“Segment is the perfect tool for combining user data across platforms and sources, which makes it possible to very quickly start extracting value from your datasets without first having to spend a huge amount of time and resources. The ability to easily identify users across their devices and different touch points has made it possible to visualize and analyze the entire digital customer journey from A to Z.”`,
      author: `Terje Sakariassen — Technical Project Manager`,
    },
    {
      description: `“Segment has allowed us to level up our data game across every department. Segment allows me to get a great understanding of where data is coming from, and where it is flowing to. This allows me to make my data-based decisions far more confidently, as I am sure it is both coming from the right place & is accurate.”`,
      author: `Seth Erdman — Product Manager`,
    },
    {
      description: `“The tracking foundation for any SaaS, Segment is an infrastructure, a tracking framework and a data hub all at once. It has been the cornerstone of our product data and operational data operations since the very beginning. In essence, Segment makes everyone much more productive, tech and marketers alike.”`,
      author: `Gilles Bertaux — CEO`,
    },
  ],
}

const Reviewers: FC = () => {
  return (
    <StyledSectionBase variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.heading}
          </CopyText.Heading>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <ColumnTrack
          overrides={{
            xl: 2,
          }}
        >
          {copy.reviews.map(({ ...review }, key) => (
            <Card key={key} {...review} />
          ))}
        </ColumnTrack>
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 24px;

    ${({ theme }) => theme.breakpoints.up(`sm`)} {
      padding-top: 40px;
    }
  }
`

export default Reviewers
